<template>
  <div>
    <div class="cover" @touchmove.stop v-show="($parent.isExhibitionPopShow && dialog) || !dialog">
      <div class="iconbox">
        <!-- 中英文切换 -->
        <div v-if="!dialog">
          <langIcon></langIcon>
        </div>
      </div>
      <div class="cover-title paddingleft">
        <div class="cover-title-main">
          {{ cover.title }}
        </div>
        <div class="cover-title-sub">
          {{ cover.secondTitle }}
        </div>
      </div>
      <section>
        <div class="cover-detail" @click.stop>
          <div class="cover-detail-title">
            <span class="cover-detail-title-word scrawl">{{word}}</span>
            <div class="cover-detail-title-icon">
              <myAudio3 ref="myaudio" :audio-url="cover.extendInfo && cover.extendInfo.audioUrl" :audio-img="cover.enterImgUrl">
              </myAudio3>
              <span @click="goVr">
                <img src="../../assets/images/bdMuseum/i-去参观-102.png" />
              </span>
            </div>
          </div>
          <div class="cover-detail-subtitle date">
            {{ cover.startAt }}-{{ cover.endAt }}<span> / 2021</span>
          </div>
          <div class="cover-detail-body" v-if="cover.intro && cover.intro.editor" :style="{height:height+'px'}">
            <div v-for="(d, i) in cover.intro.editor" :key="i">
              <template v-if="d.type === 'AiImages'">
                <div @click="previewImg(img)"
                     class="display"
                     v-for="(img, n) in d.data"
                     :key="n"
                >
                  <img
                    :src="img"
                  />
                </div>
              </template>
              <template v-else>
                <div v-html="d.data" class="htmlcontent"></div>
              </template>
            </div>
          </div>
        </div>
      </section>
    </div>
    <richImgIntract ref="richImgIntract"></richImgIntract>
  </div>
</template>

<script>
import { expoQuery } from '@/ajax/index';
import dayjs from 'dayjs';
import musicMixin from '@/mixin/music';

export default {
  name: 'Coverdetail',
  mixins: [musicMixin],
  data() {
    return {
      cover: {
        title: '',
      },
      height: 100,
    };
  },
  props: {
    dialog: { // 标示是页面还是弹窗
      type: Boolean,
      default: false,
    },
  },
  beforeRouteEnter(to, from, next) {
    console.log(to, from, 'to, from, nextto, from, next');
    let changed = false;
    document.title = '';
    if (from.params.id && +from.params.id !== +to.params.id) { // 如果是从别的页面返回的，并且中英文的id变了，那么返回的也是对应的语言id
      to.params.id = from.params.id;
      changed = true;
    }
    next((vm) => {
      if (changed) { // 如果是变了的id 那么需要在手动替换一下网址
        vm.$router.replace({
          name: 'bdMuseumcoverDetail',
          params: { id: from.params.id },
        });
      }
    });
  },
  components: {
    myAudio3: () => import(/* webpackChunkName: "myAudio3" */'../../components/myAudio3/index.vue'),
    richImgIntract: () => import(/* webpackChunkName: "richImgIntract" */'../../components/richImgIntract/index.vue'),
    langIcon: () => import(/* webpackChunkName: "langIcon" */'../../components/langIcon/index.vue'),
  },
  watch: {
    '$route.params.id': {
      handler() {
        this.expoQuery();
      },
      immediate: true,
    },
  },
  computed: {
    word() {
      const map = { 中文: '展览简介', 英文: 'Introduction' };
      return map[this.$store.state.language];
    },
  },
  created() {

  },
  mounted() {
    this.$nextTick(() => {
      if (!this.dialog) {
        document.title = this.cover.title;
      }
    });
  },
  methods: {
    computeHeight() {
      this.$nextTick(() => {
        const h = document.body.clientHeight || document.documentElement.clientHeight;
        const ih = this.$el.querySelector('.cover-detail-body').getBoundingClientRect().top;
        this.height = h - ih;
      });
    },
    previewImg(url) {
      this.$refs.richImgIntract.previewImg(url);
    },
    goVr() {
      if (this.dialog) {
        // 关闭弹窗
        this.$parent.isExhibitionPopShow = false;
        this.$refs.myaudio.pause();
      } else {
        this.$router.push({ name: 'bdMuseum', params: { id: this.$route.params.id } });
      }
    },
    async expoQuery() {
      try {
        const {
          data: { data: list },
        } = await expoQuery({ id: this.$route.params.id });
        // eslint-disable-next-line prefer-destructuring
        this.cover = list[0];
        const s = this.cover.startAt * 1000;
        const e = this.cover.endAt * 1000;
        this.cover.startAt = `${dayjs(s).month() + 1}.${dayjs(s).date()}`;
        this.cover.endAt = `${dayjs(e).month() + 1}.${dayjs(e).date()}`;
        this.cover.year = dayjs(s).year();
        if (!this.dialog) {
          document.title = this.cover.title;
        }

        this.computeHeight();
      } catch (e) {
        console.log(e);
      }
    },
  },
  beforeDestroy() {

  },
};
</script>

<style scoped lang="less">
  @rem:0.01rem;

  img {
    pointer-events: none;
  }

  .date {
    font-family: PingFangSC-Medium;
    font-size: 19*@rem;
    color: #333;
    line-height: 19*@rem;

    span {
      font-size: 12*@rem;
      line-height: 12*@rem;
    }
  }

  .scrawl {
    position: relative;
    display: inline-block;
    word-wrap: break-word;
    word-break: normal;

    &::after {
      content: '';
      position: absolute;
      bottom: -4*@rem;
      left: 0;
      display: inline-block;
      width: 100%;
      height: 9*@rem;
      background: rgba(100, 135, 250, 0.2);
      border-radius: 8.61*@rem;
    }
  }

  .iconbox {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 110;
  }

  .paddingleft {
    padding-left: 34*@rem;
  }

  .cover {
    //overflow-y: auto;
    position: fixed;
    background: #fff;
    top: 0;
    left: 0;
    width: 100%;
    overflow: hidden;
    height: 100vh;
    z-index: 300;
    // &::-webkit-scrollbar {
    //   width: 6*@rem; /*对垂直流动条有效*/
    //   display: inline-block!important;

    // }
    // &::-webkit-scrollbar-track{
    //   background-color:  rgba(82,84,102,0.10);
    //   border-radius: 3px;
    // }
    // &::-webkit-scrollbar-thumb{
    //   border-radius: 2px;
    //   background-color: #AEB5CD;
    // }
    &-title {
      padding-bottom: 48*@rem;
      padding-top: 26*@rem;
      background: #e6e8f0 url('../../assets/images/bdMuseum/背景.png') no-repeat;
      background-size: 100%;

      &-main {
        font-family: PingFangSC-Semibold;
        font-size: 27*@rem;
        color: #000;
        line-height: 27*@rem;
        font-weight: bold;
        width: 83%;
        width: calc(100% - 40 * @rem);
        word-wrap: break-word;
        word-break: normal;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }

      &-sub {
        font-family: PingFangSC-Medium;
        font-size: 17*@rem;
        color: #333;
        line-height: 17*@rem;
        margin-top: 10*@rem;
      }
    }

    &-detail {
      background: #fff;
      padding: 24*@rem 21*@rem;
      box-shadow: 0 -6*@rem 15*@rem 0 rgba(180, 190, 224, 0.2);
      border-radius: 21*@rem 21*@rem 0 0;
      margin-top: -20*@rem;
      // margin-bottom: 55*@rem;
      &-subtitle {
        margin: 27*@rem auto 22*@rem;
      }

      &-title {
        display: flex;
        align-items: center;
        justify-content: space-between;

        &-word {
          font-family: PingFangSC-Medium;
          font-size: 17*@rem;
          color: #0f121a;
          line-height: 17*@rem;
        }

        &-icon {
          display: flex;

          /deep/ .audioImg {
            img {
              width: 30*@rem;
              height: 30*@rem;
            }
          }

          img {
            width: 30*@rem;
            height: 30*@rem;
            margin-left: 20*@rem;
            border-radius: 100%;
            box-shadow: -4*@rem 4*@rem 9*@rem 0 rgba(100, 135, 250, 0.4);
            vertical-align: middle;
          }
        }
      }

      &-body {
        overflow-y: auto;
        padding-right: 3px;

        &::-webkit-scrollbar {
          width: 4px; /* 对垂直流动条有效 */
          display: inline-block !important;
        }

        &::-webkit-scrollbar-track {
          background-color: rgba(82, 84, 102, 0.1);
          border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 2px;
          background-color: #aeb5cd;
        }

        >div:nth-last-child(1) {
          margin-bottom: 60px;
        }

        .htmlcontent {
          font-family: PingFangSC-Regular;
          word-wrap: break-word;
          word-break: normal;
          font-size: 16*@rem;
          color: #333;
          line-height: 27*@rem;
        }

        img {
          max-width: 100%;
          // object-fit: cover;
          border-radius: 8px;
        }
      }
    }
  }
</style>
